<template>
  <builderall-loader :loading='showLoading'>
    <div v-show="showLoading" class="loader-content"></div>
    <div v-show="!showLoading" class="login-main-wrapper" >
      <div class="login-main-container">
        <slot name="slide-col" :classNameSlide="'slide-col'">
          <div>SLIDE</div>
        </slot>
        <slot
          name="login-col"
          :classNameLogin="'login-col'"
          :onLoginSubmit="onLoginSubmit"
          :onToggleOfficeButton="onToggleOfficeButton"
        >
          <div>LOGIN</div>
        </slot>
      </div>

      <div id="fb-root"></div> <!-- modal facebook -->
      <span class="copy copy__v2"></span> <!-- just for Clipboard instance -->

    </div>
  </builderall-loader>
</template>

<script>
    export default {
        name: 'lv5-main',
        props: ['view'],
        data: function() {
            return {
                showLoading: true
            }
        },
        methods: {
            callShowLoading(){
                let vm = this
                setTimeout(() => {
                    vm.showLoading = true
                }, 500)
            },
            onLoginSubmit(){
                this.callShowLoading()
            },
            onToggleOfficeButton(type = ''){
                // enable just when page loads
                let types = ['forgot-password', 'change-password'];
                if(types.includes(type)) {
                    this.callShowLoading()
                }
            }
        },
        mounted: async function() {
            let vm = this
            $(window).on('load', (e) => {
                vm.showLoading = false
            });
        }
    }
</script>

<style scoped lang="scss">
.loader-content {
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/login-v5/index.vue